var map = {
	"./github.svg": 2280,
	"./instagram.svg": 2281,
	"./linkedin.svg": 2282,
	"./twitter.svg": 2283
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2287;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svg ^\.\/.*\.svg$
// module id = 2287
// module chunks = 168707334958949